import instance from './DefaultApi';

export default class WareHouseMaterService {
    ControllerName = 'WareHouser';

    // get all user data
    Get(tableRequest) {
            return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/Get`, tableRequest).then(res => res);
        }

        GetDepot(tableRequest) {
            return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetDepot`, tableRequest).then(res => res);
        }
        // create new user 
    Save(Payload) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/Save`, Payload).then(res => res);
    }
    SaveDepot(Payload) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/SaveDepot`, Payload).then(res => res);
    }
    //get all warehouse for ddl
    GetWareHouseDDL(CompId) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetWareHouseDDL?CompId=` + CompId).then(res => res);
    }
    DeliveryDDL() {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${'Dispatch'}/GetDeliveryDDL`).then(res => res);
       
    }
    GetBatchDDL(selectedDeliveryId) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${'Dispatch'}/GetBatchFromDelDoc?DeliveryId=` + selectedDeliveryId).then(res => res);
    }
}